import AddPayment from "./AddPayment";

export default AddPayment;
